/*! License details at fancyapps.com/license */
var s = function s(_s) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  _s && _s.classList && t.split(" ").forEach(function (t) {
    t && _s.classList.add(t);
  });
};
export { s as addClass };